import { GlobalAppState } from '@model/state';

export const getIsLoading = (state: GlobalAppState) =>
  state.searchResults.flights.loading || state.searchResults.fromPrices.loading;

export const getSearchResultsAirports = (state: GlobalAppState) =>
  state.searchResults.flights.data.flights.map(({ outbound }) => outbound[0].departure.code);
